/* Reuse the theme's browser-local history; render current Shopify cards on demand. */
(function () {
  const KEY='marbily:recently-viewed';
  function parseHistory(raw) {
    try {
      const list=JSON.parse(raw);
      return Array.isArray(list)?[...new Set(list.filter(h=>typeof h==='string'&&/^[a-z0-9][a-z0-9-]*$/.test(h)))].slice(0,12):[];
    } catch(error) {return [];}
  }
  if(typeof module!=='undefined'&&module.exports){module.exports={parseHistory};return;}
  const states=new WeakMap();
  function history(){try{return parseHistory(localStorage.getItem(KEY));}catch(error){return [];}}
  function setup() {
    document.querySelectorAll('[data-mh-recently-viewed]').forEach(el=>{
      if(states.has(el))return;
      const track=el.querySelector('[data-mh-track]');
      const state={near:false,signature:null,request:null,pending:false};states.set(el,state);
      async function refresh(force=false) {
        if(!el.isConnected||!state.near)return;
        if(el.querySelector('dialog[open]')){state.pending=true;return;}
        const handles=history().slice(0,8),signature=handles.join('|');
        if(!force&&signature===state.signature)return;
        state.signature=signature;state.request?.abort();
        const controller=new AbortController();state.request=controller;
        if(!handles.length){track.replaceChildren();el.hidden=true;return;}
        const cards=new Array(handles.length);let cursor=0;
        async function worker() {
          while(cursor<handles.length&&!controller.signal.aborted) {
            const index=cursor++,handle=handles[index];
            try {
              const url=new URL((window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(handle),location.origin);
              url.searchParams.set('section_id','mh-recent-card');
              const response=await fetch(url,{signal:controller.signal,cache:'no-store',credentials:'same-origin'});
              if(!response.ok)continue;
              const document=new DOMParser().parseFromString(await response.text(),'text/html');
              const rendered=document.querySelector('[data-mh-recent-card]');
              if(rendered?.querySelector('[data-mh-product]'))cards[index]=rendered;
            } catch(error) {/* Missing products and network failures leave no broken card. */}
          }
        }
        await Promise.all(Array.from({length:Math.min(3,handles.length)},worker));
        if(controller.signal.aborted||!el.isConnected)return;
        if(el.querySelector('dialog[open]')){state.pending=true;return;}
        const content=document.createDocumentFragment();
        cards.filter(Boolean).forEach(card=>{while(card.firstChild)content.append(card.firstChild);});
        track.replaceChildren(content);el.hidden=!track.querySelector('[data-mh-product]');
        if(!el.hidden)el.dispatchEvent(new CustomEvent('mh:content-loaded',{bubbles:true}));
      }
      state.refresh=refresh;
      const anchor=el.closest('.shopify-section')?.previousElementSibling||el.parentElement;
      if('IntersectionObserver' in window){
        state.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){state.near=true;state.observer.disconnect();refresh();}},{rootMargin:'600px'});
        state.observer.observe(anchor);
      }else{state.near=true;refresh();}
      el.addEventListener('close',()=>{if(state.pending){state.pending=false;refresh(true);} },true);
    });
  }
  const refreshAll=force=>document.querySelectorAll('[data-mh-recently-viewed]').forEach(el=>states.get(el)?.refresh(force));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
  document.addEventListener('shopify:section:load',setup);
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-mh-recently-viewed]').forEach(el=>{states.get(el)?.request?.abort();states.get(el)?.observer?.disconnect();}));
  window.addEventListener('pageshow',event=>{if(event.persisted)refreshAll(true);});
  window.addEventListener('storage',event=>{if(event.key===KEY||event.key===null)refreshAll(false);});
})();
